import React from "react";

export const About = () => {
    return (
        <div>
            <div className="jumbotron">
                <div className="container">
                    <h1 className="display-4">About</h1>
                    <p className="lead">App Version : <strong>1.0.0</strong></p>
                </div>
            </div>
        </div>
    )
}